import axios from 'axios'
const endpoint = process.env.NODE_ENV === 'development' ? 'http://localhost:8888' : '../api'

const api = {
  getPage(route) {
    return axios.get(endpoint + '/' + route + '.json')
  },
};

export default api